module.exports = __webpack_public_path__ + "img/duck_quac_happy.6aa6efee.svg";